import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';
import { environment } from '../../../environments/environment';
import { Product } from '../../shared/classes/product';
import { ProductService } from '../../shared/services/product.service';
import { OrderService } from '../../shared/services/order.service';
import { IDinarRate, IIndexCustomer } from 'src/app/shared/Models/ICustomer';
import { CustomerService } from 'src/app/shared/services/Customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IUser } from 'src/app/shared/Models/IUser';
import { IBaseItem } from 'src/app/shared/Models/TopCollectionProduct';
import { HomeService } from 'src/app/shared/services/home.service';
import { ConfirmBoxEvokeService } from '@costlydeveloper/ngx-awesome-popup';

// imports (as you know goes to the beginning of the file).
import {
  ConfirmBoxInitializer,
  DialogLayoutDisplay,
  DisappearanceAnimation,
  AppearanceAnimation,
} from '@costlydeveloper/ngx-awesome-popup';
import { ToastrService } from 'ngx-toastr';
import {
  IIndexCoupon,
  IIndexOrderItem,
  IIndexProductRegistered,
  IOrder,
  IOrderItem,
} from 'src/app/shared/Models/IOrder';
import { PaginatedResult } from 'src/app/shared/Pagination/IPagination';
import { IIndexAccount } from 'src/app/shared/Models/IAccount';
import { parseWebAPIErrors } from 'src/app/shared/Errors/parseWebAPIErrors';
import { BuyerService } from 'src/app/shared/services/BuyerService';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss'],
})
export class CheckoutComponent implements OnInit {

  get getBarcode() {
    return this.ordertItemForm.get('barcode');
  }

  get getBuyer() {
    return this.ordertItemForm.get('buyerId');
  }

  get getQuantity() {
    return this.ordertItemForm.get('quantity');
  }

  get getUnitPrice() {
    return this.ordertItemForm.get('unitPrice');
  }

  get getStoreId() {
    return this.ordertItemForm.get('purchasePrice');
  }

  constructor(
    private fb: FormBuilder,
    public productService: ProductService,
    private customerService: CustomerService,
    private router: Router,
    private buyerService: BuyerService,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private confirmBoxEvokeService: ConfirmBoxEvokeService,
    private homeService: HomeService,
    private orderService: OrderService
  ) {
    this.isOrderTrackPlace = true;
    this.checkoutForm = this.fb.group({
      firstname: [
        '',
        [
          Validators.required,
          Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$'),
        ],
      ],
      lastname: [
        '',
        [
          Validators.required,
          Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$'),
        ],
      ],
      phone: ['', [Validators.required, Validators.pattern('[0-9]+')]],
      email: ['', [Validators.required, Validators.email]],
      address: ['', [Validators.required, Validators.maxLength(50)]],
      country: ['', Validators.required],
      town: ['', Validators.required],
      state: ['', Validators.required],
      postalcode: ['', Validators.required],
      FreeSample: [false],
    });

    this.orderForm = this.formBuilder.group({
      buyerName: [''],
      couponName: [''],
      buyerId: [null, [Validators.required]],
      orderNote: [''],
      discount: [0],
      reward: [0],
      freeSample: [false],
    });

    this.printOrderTrack();

  }
  @ViewChild('signUpNgForm') signUpNgForm: NgForm;
  @ViewChild('buyerName') buyerName: ElementRef<HTMLInputElement>;
  @ViewChild('couponQuery') couponInput: ElementRef<HTMLInputElement>;
  @ViewChild('rewardQuery') rewardInput: ElementRef<HTMLInputElement>;
  @ViewChild('discountQuery') discountInput: ElementRef<HTMLInputElement>;
  @ViewChild('matSelectBuyer') matSelectBuyer: ElementRef<HTMLInputElement>;
  @ViewChild('quantity') quantity: ElementRef<HTMLInputElement>;
  @ViewChild('qeury') qeury: ElementRef<HTMLInputElement>;
  @ViewChild('unitPrice') unitPrice: ElementRef<HTMLInputElement>;
  @ViewChild('productNameElement')


  productNameElement: ElementRef<HTMLInputElement>;

  customer$: Observable<IIndexCustomer>;
  cartItems$: Observable<IBaseItem[]>;
  dinarRate$: Observable<IDinarRate>;

  buyers$: Observable<PaginatedResult<IIndexAccount[]>>;
  products$: Observable<PaginatedResult<IIndexProductRegistered[]>>;
  coupons$: Observable<IIndexCoupon>;

  orderItems: IIndexOrderItem[] = [];
  orderItem: IOrderItem;

  isBuyerSelectDisabled = false;
  remainQuantity = 0;
  currentSearchValue = '';
  freeSample = false;
  orderTrack = 1;
  orderTrackPayment = 1;
  orderTrackPlace = 2;
  hiddenOrderButton = false;

  public checkoutForm: FormGroup;
  public products: Product[] = [];
  public payPalConfig?: IPayPalConfig;

  public amount: any;
  isRepeatReques = true;
  items: IBaseItem[];
  disabledCheckOut = true;
  confirmation = localStorage.getItem('code') ? 'دووپاتكردنه‌وه‌' : 'Confirmation';
  crderConfirmation = localStorage.getItem('code') ? 'دووپایكردنه‌وه‌ی داواكردن' : 'Order Confirmation!';

  usedCouponName = '';
  isCouponApplied = false;
  isRewardApplied = false;
  isDiscountApplied = false;
  rewardAmount = 0;

  couponDisabled = false;
  rewardDisabled = false;
  discountDisabled = false;
  isAddButtonValid = true;
  isWholeSaleAccount = false;
  isHawlerChoosen = false;

  totalPrice = 0;
  totalPriceAfterDiscount = 0;

  taxiOnDelivered: boolean;
  cashOnDelivered: boolean;


  taxiOnPickUp: boolean;
  cashOnPickUp: boolean;
  insideHawler = 'Inside Erbil';
  outsideHalwer = 'Outside Erbil';
  isOrderTrackPlace = true;

  errorMessages = {
    barcode: [{ type: 'required', message: 'Product is required.' }],
    buyerId: [{ type: 'required', message: 'buyer is required.' }],

    quantity: [
      { type: 'required', message: 'quantity is required.' },
      { type: 'min', message: 'Min quantity  is 0.' },
      { type: 'max', message: 'Max quantity  is 100000.' },
      { type: 'pattern', message: 'just number is allowed' },
    ],
    unitPrice: [
      { type: 'required', message: 'Unit Price is required.' },
      { type: 'min', message: 'Min unit price is 0.' },
      { type: 'max', message: 'Max unit price  is 100000.' },
      { type: 'pattern', message: 'just number is allowed' },
    ],
  };

  orderForm: FormGroup;
  ordertItemForm: FormGroup;
  showAlert = false;


  isDelivery = true;
  isPickUp = false;
  pay_Cash_In_person = false;

  ngOnInit(): void {

    this.spinner.show('Wait ...');


    this.customer$ = this.customerService.getCustomer$;
    this.cartItems$ = this.homeService.getCartItems$;
    this.dinarRate$ = this.customerService.getDinarRate$;

    const decimalRegex = '^[+-]?(([1-9][0-9]*)?[0-9](.[0-9]*)?|.[0-9]+)$';

    // Create the form
    this.ordertItemForm = this.formBuilder.group({
      orderItemId: [0],
      barcode: [null, Validators.required],
      productName: [''],
      quantity: [
        1,
        [
          Validators.required,
          Validators.min(0),
          Validators.max(100000),
          Validators.pattern(decimalRegex),
        ],
      ],
      unitPrice: [
        0,
        [
          Validators.required,
          Validators.min(0),
          Validators.max(100000),
          Validators.pattern(decimalRegex),
        ],
      ],
      purchasePrice: [
        0,
        [
          Validators.required,
          Validators.min(0),
          Validators.max(100000),
          Validators.pattern(decimalRegex),
        ],
      ],
    });

    this.customer$.subscribe((user: IIndexCustomer) => {
      if (!user) {
        const getUserFromLocalStorage: IUser = JSON.parse(localStorage.getItem('user'));
        if (getUserFromLocalStorage) {

          this.customerService
            .customerByIdInServer(getUserFromLocalStorage.id)
            .subscribe(c => {
              this.isHawlerChoosen = c.cityName.includes('Erbil') ? true : false;
            });
        }
      }

      if (user) {
        if (user.cityName.includes('Erbil') && user) {
          this.isHawlerChoosen = user.cityName.includes('Erbil');
        }
      }

    });

    this.cartItems$.subscribe((items: IBaseItem[]) => {
      if (this.isRepeatReques) {
        if (!items || items.length === 0) {
          this.homeService
            .baseItems('CartItem')
            .subscribe((cartItems: IBaseItem[]) => {
              this.items = cartItems;
              this.getTotalPrice(cartItems);
            });

          this.isRepeatReques = false;
          return;
        }
      }

      if (items !== undefined && items != null) {
        this.items = items;

        this.getTotalPrice(items);

        // this.getTotal.subscribe(amount=>{
        //   this.totalPrice = amount;
        // })

        this.addItemToOrderItems(items);

        this.disabledCheckOut = this.items.some(
          (x) => x.quantitiesInCartItem > x.stock
        );
      }

      const user: IUser = JSON.parse(localStorage.getItem('user'));
      if (!user) {
        this.disabledCheckOut = false;
      }
    });

    this.productService.cartItems.subscribe(
      (response) => (this.products = response)
    );


    // this.getTotal.subscribe(amount => this.amount = amount);
    // this.initConfig();


    const user: IUser = JSON.parse(localStorage.getItem('user'));
    if (user.isWholeSaleAccount.toString() === 'False') {
      this.isWholeSaleAccount = true;
    } else {
      this.isWholeSaleAccount = false;
    }

  }

  getTotalPrice(cartItems: IBaseItem[]) {
    this.totalPrice = 0;

    this.totalPrice = cartItems.reduce((prev, curr: IBaseItem) => {
      const price =
        curr.wholeSalePrice > 0
          ? curr.wholeSalePrice
          : curr.newPrice > 0
            ? curr.newPrice
            : curr.unitPrice;
      return prev + price * curr.quantitiesInCartItem;
    }, 0);
  }

  addItemToOrderItems(cartItems: IBaseItem[]) {
    for (let i = 0; i < cartItems.length; i++) {
      const element = cartItems[i];

      this.orderItem = null;
      this.orderItem = {
        barcode: element.barcode,
        purchasePrice: element.purchasePrice,
        quantity: element.quantitiesInCartItem,
        unitPrice: element.unitPrice,
      };

      this.orderItems.push(this.orderItem);
    }
  }

  // comment this becuase id oes not calculation new price or wholsesale
  // public get getTotal(): Observable<number> {
  //   return this._homeService.cartTotalAmount();
  //   // return this.productService.cartTotalAmount();
  // }

  // standard typescript method.
  openConfirmBox(items: IBaseItem[]) {
    const newConfirmBox = new ConfirmBoxInitializer();

    newConfirmBox.setTitle(this.confirmation);
    newConfirmBox.setMessage(this.crderConfirmation);

    // Choose layout color type
    newConfirmBox.setConfig({
      layoutType: DialogLayoutDisplay.SUCCESS, // SUCCESS | INFO | NONE | DANGER | WARNING
      animationIn: AppearanceAnimation.NONE, // BOUNCE_IN | SWING | ZOOM_IN | ZOOM_IN_ROTATE | ELASTIC | JELLO | FADE_IN | SLIDE_IN_UP | SLIDE_IN_DOWN | SLIDE_IN_LEFT | SLIDE_IN_RIGHT | NONE
      animationOut: DisappearanceAnimation.NONE, // BOUNCE_OUT | ZOOM_OUT | ZOOM_OUT_WIND | ZOOM_OUT_ROTATE | FLIP_OUT | SLIDE_OUT_UP | SLIDE_OUT_DOWN | SLIDE_OUT_LEFT | SLIDE_OUT_RIGHT | NONE
    });

    // Simply open the popup
    newConfirmBox.openConfirmBox$().subscribe((resp) => {
      // IConfirmBoxPublicResponse

      if (resp.success) {
        const buyer: IUser = JSON.parse(localStorage.getItem('user'));

        if (!buyer) {
          this.toastrService.info('please Login');
          return;
        }


        const order: IOrder = {
          buyerId: buyer.id,
          discount: 0,
          reward: this.orderForm.get('reward').value,
          couponName: this.orderForm.get('couponName').value,
          orderNote: '',
          orderItems: this.orderItems,
          freeSample: this.freeSample,
          email: buyer.email,
          orderTrack: this.orderTrack,
          orderTrackPayment: this.orderTrackPayment,
          orderTrackPlace: this.orderTrackPlace
        };

        this.hiddenOrderButton = true;

        this.orderService.addOrder(order).subscribe({
          next: (value) => {
            this.toastrService.success('new Order was added succesfuly');
            this.orderService._order$.next(value);
            this.cartItems$.subscribe((items) => {
              items = [];
            });
            this.homeService.deleteCartItemsByBuyer('CartItem').subscribe();
            this.homeService.baseItems('CartItem').subscribe();

            this.router.navigate(['/shop/checkout/success', '0z']);
            this.spinner.hide();

          },
          error: (error) => {
            parseWebAPIErrors(error).forEach((e: any) => {
              this.toastrService.error(e);
            });

            this.spinner.hide();
          },
        });
      }
    });
  }

  public onDisplayImage = (serverPath: string) => {
    const imageApi = environment.imageApi;
    const result = `${imageApi}/${serverPath}`;
    return result;
  }

  totalPurchases() {
    // const result = this.orderItems.reduce((sum, current) => sum + current.quantity * current.unitPrice,0);
    const result = this.totalPrice;

    return result;
  }

  onSelectedReward(event) {
    if (event) {
      this.isRewardApplied = true;
    } else {
      this.isRewardApplied = false;
    }
  }

  applyCoupon(couponName: string) {
    if (this.isCouponApplied) {
      const couponInputValue = this.couponInput.nativeElement.value;
      this.onCouponBlur(null);
      this.isCouponApplied = false;
      this.disabled();
      this.orderForm.get('couponName').setValue('');
      this.usedCouponName = '';
      this.totalPriceAfterDiscount = 0;
      this.couponInput.nativeElement.value = '';
      this.couponInput.nativeElement.disabled = false;

      return;
    }
    if (!couponName) {
      return;
    }

    if (this.usedCouponName === couponName) {
      this.toastrService.info(`You already applied this coupon.`);
      return;
    }
    this.orderService.couponByName(couponName).subscribe({
      next: (coupon: IIndexCoupon) => {
        if (coupon) {
          if (coupon.isExpired) {
            this.toastrService.warning(`This coupon is expired.`);
            return;
          }

          if (!coupon.isAvailable) {
            this.toastrService.info(`This coupon is not available.`);
            return;
          }

          if (
            this.isCouponApplied &&
            coupon.couponName === this.usedCouponName
          ) {
            this.toastrService.info(`You already applied this coupon.`);
            return;
          }

          this.isCouponApplied = true;
          this.isRewardApplied = false;
          this.isDiscountApplied = false;
          this.disabled();

          this.usedCouponName = couponName;
          this.orderForm.get('couponName').setValue(coupon.couponName);
          this.toastrService.success(
            `Successfully  %${coupon.percentage} applied.`
          );
          this.coupons$ = this.orderService.getCoupon$;
          const totalPurchases = this.totalPurchases();
          this.totalPriceAfterDiscount =
            totalPurchases - (totalPurchases * coupon.percentage) / 100;

          // this.rewardInput.nativeElement.value = '';
          this.couponInput.nativeElement.disabled = true;
        }
      },
      error: (error) => {
        parseWebAPIErrors(error).forEach((e: any) => {
          this.toastrService.warning(e);
        });
        this.orderForm.get('couponName').setValue('');
      },
    });
  }

  onCouponBlur(value: string) {
    if (!value) {
      const couponInputValue = this.couponInput.nativeElement.value;
      if (couponInputValue.length <= 0) {
        this.isCouponApplied = false;
        this.disabled();
        this.orderForm.get('couponName').setValue('');
        this.usedCouponName = '';
        this.totalPriceAfterDiscount = 0;
      }
    }
  }

  applyReward(rewardValue: number) {
    if (this.isRewardApplied) {
      this.onRewardBlur(null);
      this.isRewardApplied = false;
      this.disabled();
      this.orderForm.get('reward').setValue(0);
      this.totalPriceAfterDiscount = 0;
      // this.rewardInput.nativeElement.value = '';
      // this.rewardInput.nativeElement.disabled = false;
      return;
    }
    if (rewardValue <= 0) {
      return;
    }

    if (rewardValue !== 10) {
      this.toastrService.info(
        'You can just use $10 and total Item must be bigger than $10.'
      );
      return;
    }

    const buyer: IUser = JSON.parse(localStorage.getItem('user'));
    if (!buyer) {
      this.toastrService.info(
        'You are not login, plase log out then login again.'
      );
      return;
    }

    this.buyerService.accountReward(buyer.id).subscribe({
      next: (rewadAmount) => {
        if (this.isRewardApplied) {
          this.toastrService.info(`you are already reward applied.`);
          return;
        }

        if (rewadAmount < 10) {
          this.toastrService.info('Rward amount must be bigger than $10.');
          return;
        }

        if (rewardValue > 10) {
          this.toastrService.info('You must use $10 for each check out.');
          return;
        }

        if (rewardValue > rewadAmount) {
          this.toastrService.warning(
            'you are using more than amount of the user reward amount'
          );
          return;
        }

        if (rewardValue >= this.totalPurchases()) {
          this.toastrService.info(
            'Not applied, because applied reward is begger than total order price.'
          );
          return;
        }

        this.isCouponApplied = false;
        this.isRewardApplied = true;
        this.isDiscountApplied = false;
        this.disabled();

        this.couponInput.nativeElement.value = '';
        // this.rewardInput.nativeElement.disabled = true;

        this.orderForm.get('reward').setValue(rewardValue);
        this.toastrService.success(
          `Successfully  $${rewardValue} of reward applied.`
        );

        const totalPurchases = this.totalPurchases();

        this.totalPriceAfterDiscount = totalPurchases - rewardValue;
      },
      error: (error) => {
        parseWebAPIErrors(error).forEach((e: any) => {
          this.toastrService.warning(e);
        });
      },
    });
  }

  onRewardBlur(value: any) {
    if (!value) {
      this.isRewardApplied = false;

      this.disabled();
      this.orderForm.get('reward').setValue(0);
      // this.rewardInput.nativeElement.value = '';
      this.totalPriceAfterDiscount = 0;
    }
    if (value) {
      if (value <= 0) {
        this.isRewardApplied = false;
        this.disabled();
        this.orderForm.get('reward').setValue(0);
        // this.rewardInput.nativeElement.value = '';
        this.totalPriceAfterDiscount = 0;
      }
    }
  }

  colorCouponApplied() {
    return this.isCouponApplied ? 'green' : '';
  }

  colorRewardApplied() {
    return this.isRewardApplied ? 'green' : '';
  }

  colorDiscountApplied() {
    return this.isDiscountApplied ? 'green' : '';
  }

  disabled() {
    if (this.isCouponApplied) {
      this.couponDisabled = !this.isCouponApplied;
      this.rewardDisabled = this.isCouponApplied;
      this.discountDisabled = this.isCouponApplied;
    }

    if (this.isRewardApplied) {
      this.couponDisabled = this.isRewardApplied;
      this.rewardDisabled = !this.isRewardApplied;
      this.discountDisabled = this.isRewardApplied;
    }

    if (this.isDiscountApplied) {
      this.couponDisabled = this.isDiscountApplied;
      this.rewardDisabled = this.isDiscountApplied;
      this.discountDisabled = !this.isDiscountApplied;
    }

    if (
      !this.isCouponApplied &&
      !this.isRewardApplied &&
      !this.isDiscountApplied
    ) {
      this.couponDisabled = false;
      this.rewardDisabled = false;
      this.discountDisabled = false;
    }
  }

  onCheckFreeSample(event) {
    const isChecked = event.target.checked;
    this.freeSample = event.target.checked;
    this.orderForm.get('freeSample').setValue(isChecked);
  }


  onOrderTrack(event) {

    const value = event.target.value;
    this.isOrderTrackPlace = true;

    if (value === 'delivery') {
      this.isDelivery = true;
      this.isPickUp = false;
      this.orderTrack = 1;
      this.orderTrackPayment = 1;
      this.orderTrackPlace = 2;
    }


    if (value === 'pickup') {
      this.isDelivery = false;
      this.isPickUp = true;
      this.orderTrack = 2;
      this.orderTrackPayment = 1;
      this.orderTrackPlace = 1;
    }

    this.printOrderTrack();


  }

  onOrderTrackPayment(event) {
    const value = event.target.value;
    if (value === 'paidCashToTaxi') {
      this.isOrderTrackPlace = true;
      this.orderTrack = 1;
      this.orderTrackPayment = 1;
      this.orderTrackPlace = 2;
    }

    if (value === 'cashByBalance') {
      this.isOrderTrackPlace = false;
      this.orderTrack = 1;
      this.orderTrackPayment = 2;
      this.orderTrackPlace = 1;

    }


    if (value === 'pickUpPaidCash') {
      this.isOrderTrackPlace = false;
      this.orderTrack = 2;
      this.orderTrackPayment = 1;
      this.orderTrackPlace = 1;

    }

    if (value === 'pickUpcashByBalance') {
      this.isOrderTrackPlace = false;
      this.orderTrack = 2;
      this.orderTrackPayment = 2;
      this.orderTrackPlace = 1;

    }


    this.printOrderTrack();

  }

  onOrderTrackPlace(event) {
    const value = event.target.value;
    if (value === 'insideHawler') {
      this.orderTrackPlace = 2;
    }

    if (value === 'outsideHalwer') {
      this.orderTrackPlace = 3;
    }

    this.printOrderTrack();


  }



  printOrderTrack() {
    return;
    console.log('orderTrack: ' + this.orderTrack);
    console.log('orderTrackPayment: ' + this.orderTrackPayment);
    console.log('orderTrackPlace: ' + this.orderTrackPlace);
  }


  isInHalwer(cityName: string): boolean {
    const result = cityName.includes('Erbil');
    this.isHawlerChoosen = result;
    return this.isHawlerChoosen;
  }


}
